// extracted by mini-css-extract-plugin
export default {"button-container":"VehicleIssueForm_button-container__rO9YT","button":"VehicleIssueForm_button__GIbg-","cancel":"VehicleIssueForm_cancel__0ET43","add":"VehicleIssueForm_add__Gv7fT"};